var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactingDriverSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.95,
    height: 89.066,
    viewBox: "0 0 86.95 89.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(-175 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M256.43,74.946l-1.22-2.73h1.93a4.62,4.62,0,0,0,0-9.24h-6.06l-4.86-10.89a6.187,6.187,0,0,0-5.65-3.67h-3.96l-1.54-4.26a5.268,5.268,0,0,0-4.96-3.48H218.2a5.278,5.278,0,0,0-4.96,3.48l-1.54,4.26h-3.87a6.187,6.187,0,0,0-5.65,3.67l-4.86,10.89h-6.06a4.62,4.62,0,0,0,0,9.24h1.93l-1.22,2.73a7.515,7.515,0,0,0-5.56,7.25v15.49a1.946,1.946,0,0,0,1.95,1.95h4.82v5.47a3.956,3.956,0,0,0,3.96,3.96h4.92a3.956,3.956,0,0,0,3.96-3.96v-5.47h36.23v5.47a3.956,3.956,0,0,0,3.96,3.96h4.92a3.956,3.956,0,0,0,3.96-3.96v-5.47H260a1.946,1.946,0,0,0,1.95-1.95V82.2a7.533,7.533,0,0,0-5.56-7.25ZM248.92,91.6h-.34a4.46,4.46,0,1,1,0-8.92h.34a4.46,4.46,0,1,1,0,8.92Zm-48.7,0h-.34a4.46,4.46,0,1,1,0-8.92h.34a4.46,4.46,0,0,1,0,8.92Zm8.74-35.26h30.5l6.41,14.36H202.55Zm25.68,36.12H213.79a5.31,5.31,0,0,1,0-10.62h20.85a5.31,5.31,0,0,1,0,10.62Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M193.86,45.916a2.243,2.243,0,0,0,1.08,2.99,2.163,2.163,0,0,0,.96.21,2.25,2.25,0,0,0,2.04-1.29,6.227,6.227,0,0,1,1.78-2.25,6.066,6.066,0,0,1,2.71-1.21,2.251,2.251,0,0,0-.8-4.43,10.648,10.648,0,0,0-7.76,5.98Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M188.63,42.846a12.624,12.624,0,0,1,10.46-8.13,2.248,2.248,0,1,0-.49-4.47,17.127,17.127,0,0,0-14.19,11.02,2.25,2.25,0,0,0,1.32,2.9,2.2,2.2,0,0,0,.79.14A2.261,2.261,0,0,0,188.63,42.846Z",
    fill: "#c7c8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M195.97,24.486a2.247,2.247,0,0,0-.36-4.48,23.585,23.585,0,0,0-20.49,15.95,2.257,2.257,0,0,0,1.4,2.86,2.28,2.28,0,0,0,.73.12,2.252,2.252,0,0,0,2.13-1.52A19.036,19.036,0,0,1,195.97,24.5Z",
    fill: "#c7c8c7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactingDriverSmallIcon);
export default __webpack_public_path__ + "static/media/contacting-driver-small-icon.ae78bb28.svg";
export { ForwardRef as ReactComponent };